import { defineMessages } from 'react-intl';

export const nextSalesOpeningScope = 'app.components.nextSalesOpening';

export const nextSalesOpeningMessages = {
  upcomingTitle: {
    id: `${nextSalesOpeningScope}.upcomingTitle`,
    defaultMessage: 'Prochaine ouverture des ventes',
    en: 'Next ticket sales opening',
    it: 'Prossima apertura delle vendite',
    es: 'Próxima apertura de ventas',
    de: 'Nächster Verkaufsstart',
    nl: 'Volgende verkoopstart',
  },
  // Written to stand alone as the answer to "quand ouvrent les ventes ?" — it
  // is the block search engines lift into a featured snippet.
  upcomingBody: {
    id: `${nextSalesOpeningScope}.upcomingBody`,
    defaultMessage:
      'Les billets {brand} pour les voyages du {from} au {to} sont mis en vente le {opensAt} (heure de Paris).',
    en: 'Tickets for {brand} journeys between {from} and {to} go on sale on {opensAt} (Paris time).',
    it: 'I biglietti {brand} per i viaggi dal {from} al {to} sono in vendita dal {opensAt} (ora di Parigi).',
    es: 'Los billetes {brand} para viajes del {from} al {to} salen a la venta el {opensAt} (hora de París).',
    de: '{brand}-Tickets für Reisen vom {from} bis {to} sind ab {opensAt} (Pariser Zeit) buchbar.',
    nl: '{brand}-tickets voor reizen van {from} tot {to} gaan op {opensAt} (Parijse tijd) in de verkoop.',
  },
  openedTitle: {
    id: `${nextSalesOpeningScope}.openedTitle`,
    defaultMessage: 'Les ventes sont ouvertes',
    en: 'Ticket sales are open',
    it: 'Le vendite sono aperte',
    es: 'Las ventas están abiertas',
    de: 'Der Verkauf hat begonnen',
    nl: 'De verkoop is geopend',
  },
  openedBody: {
    id: `${nextSalesOpeningScope}.openedBody`,
    defaultMessage:
      'Les billets {brand} pour les voyages du {from} au {to} sont en vente depuis le {opensAt}. Les meilleurs prix partent en quelques heures : comparez dès maintenant.',
    en: 'Tickets for {brand} journeys between {from} and {to} have been on sale since {opensAt}. The cheapest fares go within hours — compare now.',
    it: 'I biglietti {brand} per i viaggi dal {from} al {to} sono in vendita dal {opensAt}. I prezzi migliori si esauriscono in poche ore: confronta subito.',
    es: 'Los billetes {brand} para viajes del {from} al {to} están a la venta desde el {opensAt}. Los mejores precios vuelan en pocas horas: compara ahora.',
    de: '{brand}-Tickets für Reisen vom {from} bis {to} sind seit {opensAt} buchbar. Die günstigsten Preise sind binnen Stunden weg — jetzt vergleichen.',
    nl: '{brand}-tickets voor reizen van {from} tot {to} zijn sinds {opensAt} te koop. De laagste prijzen zijn binnen enkele uren weg — vergelijk nu.',
  },
  // The one answer a rail-only comparator cannot give, and the reason a
  // traveller who arrives too early should stay rather than bounce.
  meanwhile: {
    id: `${nextSalesOpeningScope}.meanwhile`,
    defaultMessage:
      'En attendant, les trajets en bus et en covoiturage sont déjà réservables pour ces dates.',
    en: 'In the meantime, coach and carpooling journeys can already be booked for those dates.',
    it: 'Nel frattempo, i viaggi in autobus e in carpooling sono già prenotabili per queste date.',
    es: 'Mientras tanto, los trayectos en autobús y en carpooling ya se pueden reservar para esas fechas.',
    de: 'In der Zwischenzeit sind Bus- und Mitfahrgelegenheiten für diese Daten bereits buchbar.',
    nl: 'Ondertussen zijn bus- en carpoolritten voor die data al te boeken.',
  },
};

export default defineMessages(nextSalesOpeningMessages);
